import { withBase } from '../../MapSharedData';

/**
 * Module-level cache so we never refetch the same per-region polygons file.
 * Keyed by the resolved URL (after BASE_URL prefix has been applied).
 */
const polygonCache = new Map<string, Promise<GeoJSON.FeatureCollection>>();

export function loadPostcodePolygons(url: string): Promise<GeoJSON.FeatureCollection> {
  const finalUrl = withBase(url);
  let p = polygonCache.get(finalUrl);
  if (p) return p;
  p = fetch(finalUrl).then((res) => {
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json();
  });
  polygonCache.set(finalUrl, p);
  return p;
}
